(() => {
  const bikeTypes = {
    road: {
      label: 'Rennrad / Fixie',
      factor: 0.665,
      factorLabel: '0,665',
    },
    trekking: {
      label: 'City / Trekking',
      factor: 0.66,
      factorLabel: '0,66',
    },
    mtb: {
      label: 'Mountainbike',
      factor: 0.57,
      factorLabel: '0,57',
    },
  };

  const formatCentimeters = (value) =>
    new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 }).format(value);

  document.querySelectorAll('[data-fsm-frame-calculator]').forEach((calculator) => {
    const input = calculator.querySelector('input[name="schrittlaenge"]');
    const typeSelect = calculator.querySelector('select[name="radtyp"]');
    const result = calculator.querySelector('output');
    const availableFrame = Number(calculator.dataset.availableFrame);
    if (!input || !typeSelect || !result) return;

    calculator.addEventListener('submit', (event) => event.preventDefault());

    const showResult = (heading, text) => {
      const strong = document.createElement('strong');
      strong.textContent = heading;
      result.replaceChildren(strong, document.createTextNode(` ${text}`));
    };

    const update = () => {
      const inseam = input.valueAsNumber;
      if (!Number.isFinite(inseam)) {
        result.replaceChildren();
        return;
      }

      if (inseam < 60 || inseam > 120) {
        showResult('Bitte Messwert prüfen', 'Gib eine Schrittlänge zwischen 60 und 120 cm ein.');
        return;
      }

      const selectedType = bikeTypes[typeSelect.value] || bikeTypes.road;
      const orientation = inseam * selectedType.factor;
      const calculation = `Berechnung: ${formatCentimeters(inseam)} cm × ${selectedType.factorLabel}. `;
      let assessment = '';

      if (typeSelect.value === 'road' && Number.isFinite(availableFrame)) {
        const difference = availableFrame - orientation;
        const distance = formatCentimeters(Math.abs(difference));

        if (Math.abs(difference) < 0.5) {
          assessment = `Der verfügbare ${availableFrame}-cm-Rahmen trifft diesen Richtwert auf den nächsten Zentimeter. `;
        } else if (difference > 0) {
          assessment = `Der verfügbare ${availableFrame}-cm-Rahmen liegt rechnerisch rund ${distance} cm darüber. `;
        } else {
          assessment = `Der verfügbare ${availableFrame}-cm-Rahmen liegt rechnerisch rund ${distance} cm darunter. `;
        }
      } else {
        assessment = 'Das WOLFF ist ein Fixie. Für dieses Rad ist deshalb die Auswahl „Rennrad / Fixie“ maßgeblich. ';
      }

      showResult(
        `Richtwert ${selectedType.label}: ${formatCentimeters(orientation)} cm`,
        `${calculation}${assessment}Rahmengeometrie, Proportionen und Probefahrt bleiben entscheidend.`
      );
    };

    input.addEventListener('input', update);
    input.addEventListener('change', update);
    typeSelect.addEventListener('change', update);
  });
})();
